'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _actionToReducerMap;

var _immutable = require('immutable');

var _constants = require('../constants');

var _common = require('../utils/common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = exports.defaultState = (0, _immutable.fromJS)({
  quickDepositConfig: {
    chatUrl: '',
    obUrl: '',
    tdsTermUrl: '',
    tdsTermUrlV2: '',
    blockedSchemesUrl: '',
    layout: _constants.QD_DEFAULT_LAYOUT,
    jurisdiction: ''
  },
  quickDepositInitData: {
    amount: '0',
    amountButtons: [],
    pmtSource: '',
    showCloseButton: false,
    forceHideDLT: false,
    hideDLTforCountryCodes: ['UK'],
    showOtherDepositMethodsLink: false,
    submitText: null,
    submitTextKey: null,
    trackingId: ''
  },
  quickDepositTrackingData: {
    timeElapsed: null,
    submitCount: 0
  },
  quickDepositData: {
    activeCardMethod: {},
    activeDeposit: {},
    lastActiveCardIndex: null
  },
  quickDepositStatus: {
    messageData: {},
    status: _constants.QD_STATUS_INACTIVE
  },
  currency: {},
  countryCode: null,
  hasPlayerSetAmount: false,
  isDefaultCardChanged: false,
  isApplePayAvailable: false,
  quickDeposit3DSData: {},
  formWasFocused: false,
  errorMessage: null
});

/**
 * Returns initialized deposits status data.
 * @param {StateType} state Immutable List
 * @returns {Map} default store state
 */
var setIsApplePayAvailable = function setIsApplePayAvailable(state, action) {
  return state.setIn(['isApplePayAvailable'], action.availability);
};

/**
 * Returns initialized deposits status data.
 * @param {StateType} state Immutable List
 * @returns {Map} default store state
 */
var resetDepositStatusToDefault = function resetDepositStatusToDefault(state) {
  return state.setIn(['quickDepositStatus'], defaultState.getIn(['quickDepositStatus']));
};

/**
 * Returns initialized deposits data.
 * @param {StateType} state Immutable List
 * @returns {Map} default store state
 */
var resetDepositStateToDefault = function resetDepositStateToDefault(state) {
  return state.setIn(['quickDepositData'], defaultState.getIn(['quickDepositData'])).setIn(['quickDeposit3DSData'], defaultState.getIn(['quickDeposit3DSData']));
};

/**
 * Returns initialized init data.
 * @param {StateType} state Immutable List
 * @returns {Map} default store state
 */
var resetInitDataToDefault = function resetInitDataToDefault(state) {
  return state.setIn(['quickDepositInitData'], defaultState.getIn(['quickDepositInitData'])).setIn(['quickDepositTrackingData'], defaultState.getIn(['quickDepositTrackingData']));
};

/**
 * Open component reducer
 * Merges default init config with init config object
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var openComponent = function openComponent(state, action) {
  return state.setIn(['quickDepositInitData'], defaultState.getIn(['quickDepositInitData'])).mergeIn(['quickDepositInitData'], (0, _immutable.fromJS)(action.config)).setIn(['quickDepositTrackingData'], defaultState.getIn(['quickDepositTrackingData'])).setIn(['quickDepositTrackingData', 'timeElapsed'], Date.now()).setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_ACTIVE);
};

/**
 * Closing app reducer
 * @param {StateType} state Immutable List
 * @returns {StateType} The new state
 */
var closingComponent = function closingComponent(state) {
  return resetInitDataToDefault(resetDepositStateToDefault(resetDepositStatusToDefault(state))).setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_CLOSING);
};

/**
 * Close app reducer
 * @param {StateType} state Immutable List
 * @returns {StateType} The new state
 */
var closeComponent = function closeComponent(state) {
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_CLOSED);
};

/**
 * Set config reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var performConfigReceived = function performConfigReceived(state, action) {
  return state.mergeIn(['quickDepositConfig'], (0, _immutable.fromJS)(action.config));
};

var updateQuickDepositInitDataReducer = function updateQuickDepositInitDataReducer(state, action) {
  return state.mergeIn(['quickDepositInitData'], (0, _immutable.fromJS)(action.payload));
};

var setPlayerAmountSelection = function setPlayerAmountSelection(state, action) {
  return state.setIn(['hasPlayerSetAmount'], action.payload);
};

/**
 * Set payment methods reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var setPaymentMethodsAndPaymentData = function setPaymentMethodsAndPaymentData(state, action) {
  return state.setIn(['quickDepositData', 'activeCardMethod'], (0, _immutable.fromJS)(action.pmtMethod)).setIn(['quickDepositData', 'lastActiveCardIndex'], (0, _immutable.fromJS)(action.pmtMethod.cardIndex)).setIn(['currency', 'ccy'], action.pmtData.currencyCode).setIn(['currency', 'symbol'], (0, _common.getCurrencySymbol)(action.pmtData.currencyCode)).setIn(['countryCode'], action.pmtData.countryCode).setIn(['isDefaultCardChanged'], action.pmtData.isDefaultCardChanged).setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_ACTIVE);
};

/**
 * Open component reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var fetchPmtMethods = function fetchPmtMethods(state) {
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_INITIALIZING);
};

/**
 * Deposit reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var performDeposit = function performDeposit(state, action) {
  var depositData = action.depositData.toJS();
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_PMT_SUBMITTING).setIn(['quickDepositData', 'activeDeposit', _constants.QD_RF_FIELD_CARDID], depositData[_constants.QD_RF_FIELD_CARDID]).setIn(['quickDepositData', 'activeDeposit', _constants.QD_RF_FIELD_EXPIRY_DATE], depositData[_constants.QD_RF_FIELD_EXPIRY_DATE]).setIn(['quickDepositData', 'activeDeposit', _constants.QD_RF_FIELD_AMOUNT], depositData[_constants.QD_RF_FIELD_AMOUNT]).setIn(['quickDepositData', 'activeDeposit', _constants.QD_RF_FIELD_CVV], depositData[_constants.QD_RF_FIELD_CVV]).set('formWasFocused', false).setIn(['quickDepositTrackingData', 'submitCount'], state.getIn(['quickDepositTrackingData', 'submitCount']) + 1);
};

/**
 * Deposit succeded reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var performDepositSucceded = function performDepositSucceded(state, action) {
  var result = action.result || {};
  result.currency = result.currency ? result.currency : state.getIn(['currency', 'symbol']);
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_PMT_SUCCEDED).setIn(['quickDepositStatus', 'messageData'], (0, _immutable.fromJS)(result)).setIn(['quickDepositData', 'activeCardMethod', 'consent_given'], 'Y');
};

var performApayDepositSucceded = function performApayDepositSucceded(state, action) {
  var result = action.result || {};
  result.currency = result.currency ? result.currency : state.getIn(['currency', 'symbol']);
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_PMT_SUCCEDED).setIn(['quickDepositStatus', 'messageData'], (0, _immutable.fromJS)(result));
};

/**
 * Restart deposit reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var restartDeposit = function restartDeposit(state) {
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_ACTIVE).setIn(['quickDepositData', 'activeDeposit'], (0, _immutable.fromJS)({}));
};

/**
 * Sets formWasFocused to true
 * @param {StateType} state Immutable List
 * @returns {StateType} The new state
 */
var setFormWasFocused = function setFormWasFocused(state) {
  return state.set('formWasFocused', true);
};

/**
 * Deposit failed reducer
 * @param {StateType} state Immutable List
 * @returns {StateType} The new state
 */
var performDepositFailed = function performDepositFailed(state, action) {
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_PMT_FAILED).set('errorMessage', (0, _immutable.fromJS)(action.error ? action.error.message : '')).setIn(['quickDepositData', 'activeDeposit'], (0, _immutable.fromJS)({}));
};

/**
 * Fetch payment methods reducer
 * @param {StateType} state Immutable List
 * @returns {StateType} The new state
 */
var performFetchPmtMethodsFailed = function performFetchPmtMethodsFailed(state) {
  return resetDepositStatusToDefault(state).setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_FAILED);
};

/**
 * init 3ds reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var performInit3DS = function performInit3DS(state, action) {
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_3DS).setIn(['quickDeposit3DSData'], (0, _immutable.fromJS)(action.data));
};

/**
 * init 3ds reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */
var performInit3DSv2 = function performInit3DSv2(state, action) {
  return state.setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_3DS_V2).setIn(['quickDeposit3DSData'], (0, _immutable.fromJS)(action.data));
};

/**
 * complete 3ds reducer
 * @param {StateType} state Immutable List
 * @returns {StateType} The new state
 */
var performComplete3DS = function performComplete3DS(state) {
  return state.setIn(['quickDeposit3DSData'], (0, _immutable.fromJS)({})).setIn(['quickDepositStatus', 'status'], _constants.QD_STATUS_PMT_SUBMITTING);
};

/**
 * A map from action types to reducers
 * @type {ActionToReducerMapType}
 */
var actionToReducerMap = (_actionToReducerMap = {}, (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_OPEN_RECEIVED, openComponent), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_CLOSING, closingComponent), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_CLOSED, closeComponent), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_CONFIG_RECEIVED, performConfigReceived), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_UPDATE_INIT_DATA, updateQuickDepositInitDataReducer), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_FETCH_PMT_METHODS, fetchPmtMethods), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_FETCH_PMT_METHODS_SUCCEDED, setPaymentMethodsAndPaymentData), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_FETCH_PMT_METHODS_FAILED, performFetchPmtMethodsFailed), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_PERFORM_DEPOSIT, performDeposit), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_PERFORM_DEPOSIT_SUCCEDED, performDepositSucceded), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_PERFORM_APAY_DEPOSIT_SUCCEDED, performApayDepositSucceded), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_PERFORM_DEPOSIT_FAILED, performDepositFailed), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_INIT3DS, performInit3DS), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_INIT3DS_V2, performInit3DSv2), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_COMPLETE3DS, performComplete3DS), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_RESTART_DEPOSIT, restartDeposit), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_SET_IS_APPLE_PAY_AVAILABLE, setIsApplePayAvailable), (0, _defineProperty3.default)(_actionToReducerMap, _constants.QD_ACTION_SET_PLAYER_AMOUNT, setPlayerAmountSelection), (0, _defineProperty3.default)(_actionToReducerMap, '@@redux-form/FOCUS', setFormWasFocused), _actionToReducerMap);

/**
 * Quick deposit reducer
 * @param {StateType} state Immutable List
 * @param {CommonActionType} action The action dispatched
 * @returns {StateType} The new state
 */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (actionToReducerMap[action.type]) {
    return actionToReducerMap[action.type](state, action);
  }
  return state;
};